import { SHOW_VIDEO_UPLOAD_MODAL } from 'actions/videoUploads';

const DEFAULT_STATE = {
  showVideoUploadModal: false,
};

const videoUploadsReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case SHOW_VIDEO_UPLOAD_MODAL:
      return {
        ...state,
        showVideoUploadModal: action.showVideoUploadModal,
      };
    default:
      return state;
  }
};

export default videoUploadsReducer;
